var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c681d3e9d243d8c26892c0a0a60648c1.svg#Z';
                    var viewUrl = 'sprites.c681d3e9d243d8c26892c0a0a60648c1.svg#view-Z';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 46',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };